import { authFetch } from '@flexibilitypay/shared';

export interface Provincia {
  idProvincia: string;
  codigoIsoProvincia: string;
  nombreProvincia: string;
  nombreLocalidad: string | null;
  idPais: string;
  nombrePais: string;
}

// Debe coincidir con providerMapping.argentinaId del wrapper.
// En dev, el wrapper carga provider-mapping.development.json que tiene
// onboarding.idPaisWeb = '00000000-0000-0000-0000-000000000002'.
export const ARGENTINA_ID_DEFAULT = '00000000-0000-0000-0000-000000000002';

export async function fetchProvincias(idPaisWeb: string): Promise<Provincia[]> {
  const response = await authFetch(`/OnBoarding/Provincias/Pais/${idPaisWeb}`);
  if (!response.ok) {
    throw new Error(`Error ${response.status} al obtener provincias`);
  }
  return (await response.json()) as Provincia[];
}
